/**
 * @module Section-Home1-About
 */

import { NavLink } from "react-router-dom";
import { navUrl } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionAbout } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
import { useRef } from "react";
gsap.registerPlugin(ScrollTrigger, SplitText);

/**
 * 
 * @param props : Data supplied to display About Us
 * @returns Wrapper element for about us content
 */
const SectionHome1About = (
    props: {
        _about: TypeSectionAbout
    }
) => {

   
    return (
        <div className="section-full p-t120 p-b90 site-bg-white av-about-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2">
            <div className="section-content">
                <div className="container">
                    <SectionHome1AboutContent _about={props._about} />
                </div>
            </div>
        </div>
    )
}

/**
 * 
 * @param props : Data supplied to hold about us content
 * @returns Markup for about us content
 */
export const SectionHome1AboutContent = (
    props: {
        _about: TypeSectionAbout
    }
) => {
    const { _about } = props;
    const container = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
    //   let split = SplitText.create(".about_para_animation", {
    //     type: "lines",
    //   });
 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
        //   markers: true
        },
      });
    //   tl.fromTo(
    //     ".reveal",
    //     { scale: 0.8, opacity: 0 },
    //     { scale: 1, duration: 1, opacity: 1 },
    //   )

tl.fromTo(
          ".about_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
          }, "0"
        ).fromTo(
          ".image_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          }, "0"
        )
        .fromTo(
          ".about_para_animation",
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0.4"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
    return (
        <div className="row" ref={container}>
            <div className="col-lg-6 col-md-12 m-b30">
                <div className="av-about-media-section">
                    {/* <div className="av-ver-text">
                        <span>{_about.experience}</span>
                    </div> */}
                    <div className="av-large-image">
                        <AvertImage src={_about.image} alt="#" className="image_animation"/>
                        {/* <div className="av-about-chart">
                            <AvertImage src="images/ab-2.png" alt="#" />
                        </div> */}
                    </div>
                    <div className="av-ab-dot-left">
                        <AvertImage src="images/ab-dotts.png" alt="#" />
                    </div>
                    <div className="av-ab-dot-right">
                        <AvertImage src="images/ab-dotts.png" alt="#" />
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-md-12 m-b30">
                <div className="av-about-content-section">
                    <div className="av-content-title">
                        <h2 className="av-large-title about_heading_animation">{_about.title}</h2>
                        <div className="about_para_animation" dangerouslySetInnerHTML={
                            { __html: _about.description }
                        }></div>
                    </div>
                {_about.mission &&    <div className="av-icon-box-wrap p-t30 p-b30">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 about_para_animation">
                                <div className="av-icon-style-left">
                                    <div className="av-media">
                                        <AvertImage src="images/icon/ic-1.png" alt="icon" />
                                    </div>
                                    <div className="av-content">
                                        <h3 className="av-title">Increased Growth</h3>
                                        <p>{_about.mission}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 about_para_animation">
                                <div className="av-icon-style-left">
                                    <div className="av-media">
                                        <AvertImage src="images/icon/ic-2.png" alt="icon" />
                                    </div>
                                    <div className="av-content">
                                        <h3 className="av-title">Increased Focus</h3>
                                        <p>{_about.vision}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>} 
                     {/*      <div className="av-about-content-ftr">
                   <NavLink to={navUrl.pages(route.pages.CASE_DETAIL)} className="site-button">
                            Discover More
                            <i className="fa fa-plus" />
                        </NavLink>
                       {
                            _about.video &&
                            <a href={_about.video!} className="mfp-video ac-text-circle-btn">
                                <i className="fa fa-play" />
                                <AvertImage className="spinner-object" src="images/icon/ic-3.png" alt="text" />
                            </a>
                        } 
                    </div>*/}
                </div>
            </div>
        </div>
    )
}

export default SectionHome1About;